import { render, staticRenderFns } from "./CombinationsConfiguratorTemplate.vue?vue&type=template&id=8a0be352&scoped=true"
import script from "./CombinationsConfiguratorTemplate.vue?vue&type=script&lang=ts"
export * from "./CombinationsConfiguratorTemplate.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsConfiguratorTemplate.vue?vue&type=style&index=0&id=8a0be352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0be352",
  null
  
)

export default component.exports